/* src/app/builder-screen-beta/ai-suggestions/ai-suggestions-panel.component.scss */
.ai-suggestions-content {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.ai-suggestions-content .component-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
}
.ai-suggestions-content .component-info-header .component-type-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ai-suggestions-content .component-info-header .component-type-info .component-id {
  font-size: 12px;
  color: #8c8c8c;
  font-family: "Courier New", monospace;
}
.ai-suggestions-content .loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.ai-suggestions-content .loading-state .loading-content {
  text-align: center;
}
.ai-suggestions-content .loading-state .loading-content p {
  margin-top: 16px;
  color: #8c8c8c;
  font-size: 14px;
}
.ai-suggestions-content .suggestions-list {
  flex: 1;
  overflow-y: auto;
}
.ai-suggestions-content .suggestions-list .no-suggestions {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.ai-suggestions-content .suggestions-list .suggestion-card {
  margin-bottom: 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.ai-suggestions-content .suggestions-list .suggestion-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.ai-suggestions-content .suggestions-list .suggestion-card.impact-high {
  border-left: 4px solid #ff4d4f;
}
.ai-suggestions-content .suggestions-list .suggestion-card.impact-medium {
  border-left: 4px solid #faad14;
}
.ai-suggestions-content .suggestions-list .suggestion-card.impact-low {
  border-left: 4px solid #52c41a;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-header {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-header .suggestion-icon {
  font-size: 20px;
  color: #1890ff;
  flex-shrink: 0;
  margin-top: 2px;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-header .suggestion-title-area {
  flex: 1;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-header .suggestion-title-area .suggestion-title {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  line-height: 1.2;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-header .suggestion-title-area .suggestion-meta {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-description {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: #595959;
  line-height: 1.5;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes {
  margin-bottom: 16px;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes h5 {
  margin: 0 0 8px 0;
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
  text-transform: uppercase;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item:last-child {
  margin-bottom: 0;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item .property-name {
  background: #e6f7ff;
  color: #1890ff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item .change-arrow {
  color: #8c8c8c;
  font-size: 12px;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item .property-value {
  background: #f6ffed;
  color: #52c41a;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .confidence-score {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .confidence-score .confidence-label {
  font-size: 12px;
  color: #8c8c8c;
  white-space: nowrap;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .confidence-score .ant-progress {
  flex: 1;
}
.ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .confidence-score .confidence-value {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 600;
  white-space: nowrap;
}
.ai-suggestions-content .no-component-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}
[data-theme=dark] .ai-suggestions-content .component-info-header {
  border-bottom-color: #303030;
}
[data-theme=dark] .ai-suggestions-content .component-info-header .component-type-info .component-id {
  color: #bfbfbf;
}
[data-theme=dark] .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-header .suggestion-title-area .suggestion-title {
  color: #ffffff;
}
[data-theme=dark] .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-description {
  color: #bfbfbf;
}
[data-theme=dark] .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes {
  background: #1f1f1f;
}
[data-theme=dark] .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes h5 {
  color: #bfbfbf;
}
[data-theme=dark] .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item .property-name {
  background: #111a2c;
  color: #69c0ff;
}
[data-theme=dark] .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item .property-value {
  background: #162312;
  color: #95de64;
}
[data-theme=dark] .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .confidence-score .confidence-label,
[data-theme=dark] .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .confidence-score .confidence-value {
  color: #bfbfbf;
}
@media (max-width: 768px) {
  .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .suggestion-header .suggestion-icon {
    align-self: flex-start;
  }
  .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .ai-suggestions-content .suggestions-list .suggestion-card .suggestion-content .property-changes .changes-list .change-item .change-arrow {
    transform: rotate(90deg);
  }
}
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.suggestion-card {
  animation: slideInRight 0.3s ease-out;
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.loading-content nz-icon {
  animation: pulse 2s infinite;
}
/*# sourceMappingURL=ai-suggestions-panel.component.css.map */
